import { render, staticRenderFns } from "./UpdateTermicCourseStatusConfirmationDialog.vue?vue&type=template&id=5b71266d"
import script from "./UpdateTermicCourseStatusConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./UpdateTermicCourseStatusConfirmationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports